.label {
  width: 140px;
  text-align: right;
}
